import type { FaireProductEntity } from "../../entity_types/product";

export const p_tnsphxruwm: FaireProductEntity = {
  token: "p_tnsphxruwm",
  type: "product",
  name: "Crystal Goddess Bodies",
  brandToken: "b_5wk9sqf7b2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/626861bfffbf05c4c704f2f0530904a7b6374c3f3e479ed2982d4c0a410ce2c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12ba9cecf37d7b2f8fdf22c624cdf351c52efda5c946695b0d99c1aaa7aec062.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "Choose the material of your fun crystal carving. Many of our carvings have multiple materials available and while we will try to update photos when new materials come in, there may be a gap in some updates. Please note most photos are the exact piece you will get, however sometimes we have duplicate shapes in the same material so there may be some variant in what you receive as these are natural crystals and minerals and no two pieces are exactly alike.\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:34.489Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
